import { MY_DRAWN_AREA } from '../../constants/search';
import axios, { API_URL } from '../../services/axios';
import { MapBounds } from '../../types/map';
import { getFilters, getNlPFilters } from '../../utils/search';
import { clearNlpData, setSearch, setSearchResultParams } from '../search';
import { AppThunk } from '../store';
import { setPolygons, setMarkers, setError, setLoading } from './map.slice';

type GetMarkers = (imageLocator: string, bounds: MapBounds | undefined, zoom: number, polyId?: number) => AppThunk;

type NewPolygon = (bounds: MapBounds, zoom: number, line: number[], subtract: boolean) => AppThunk;

export const getMarkers: GetMarkers = (imageLocator, bounds, zoom) => async (dispatch, getState) => {
  dispatch(setLoading(true));

  const { search } = getState();

  try {
    const filtersString = await getFilters(search.filters, dispatch);

    const result = await axios(
      {
        method: 'GET',
        url: `${API_URL}/search-map/properties?${filtersString}`,
        params: {
          format: 'geoJson',
          q: search.text,
          ...bounds,
          zoom,
          imageLocator,
        },
      },
      dispatch,
    );

    dispatch(
      setMarkers({
        markers: result.data.markers,
        bounds,
        savable: result.data.savable,
        savedSearch: result.data.savedSearch,
        centre: result.data.centre,
        northWest: result.data.northWest,
        southEast: result.data.southEast,
        url: result.data.url,
        zoom: result.data.zoom,
        params: result.data.params,
      }),
    );

    dispatch(setPolygons(result.data.polygons.coordinates));
    dispatch(setSearchResultParams(result.data.params));
  } catch (err: any) {
    dispatch(setError(err));
  }

  dispatch(setLoading(false));
};

export const newPolygon: NewPolygon = (bounds, zoom, line, subtract) => async (dispatch, getState) => {
  try {
    const { search, map } = getState();

    const result = await axios(
      {
        method: 'POST',
        url: `${API_URL}/search-map/polygons?format=geoJson`,
        data: {
          params: map.params,
          polyIds: search.filters.polyIds,
          northEast: {
            lat: bounds.north,
            lng: bounds.east,
          },
          southWest: {
            lat: bounds.south,
            lng: bounds.west,
          },
          zoom,
          line,
          subtract,
        },
      },
      dispatch,
    );

    const { nlpFilters } = getNlPFilters(search.nlpData?.params, search.nlpData?.filterItems);
    const filters = {
      ...search.filters,
      ...nlpFilters,
      radius: '',
      polyIds: [...result.data.polygonIds],
    };

    dispatch(
      setSearch({
        text: MY_DRAWN_AREA,
        filters,
      }),
    );

    dispatch(clearNlpData());
    dispatch(setPolygons(result.data.coordinates));
  } catch (err: any) {
    dispatch(setError(err));
  }
};
